var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState } from 'react';
import { createPrefixCls } from '../_utils/string';
import Input from '../input';
import Confirm from './confirm';
const prefixCls = createPrefixCls('prompt');
export const Prompt = (_a) => {
    var { value, placeholder, maxLength, onOk } = _a, restProps = __rest(_a, ["value", "placeholder", "maxLength", "onOk"]);
    const [inputValue, setInputValue] = useState(value);
    const handleChange = useCallback((e) => {
        setInputValue(e.target.value);
    }, []);
    const handleOk = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (onOk) {
            const okRes = yield onOk(inputValue);
            return okRes;
        }
    }), [inputValue, onOk]);
    return (React.createElement(Confirm, Object.assign({}, restProps, { onOk: handleOk, content: (React.createElement(Input, { wrapClassName: prefixCls('input'), placeholder: placeholder, value: inputValue, maxLength: maxLength, allowClear: true, onChange: handleChange })) })));
};
export default Prompt;
